import { Component, Prop, h, Element, Event, EventEmitter, Listen } from '@stencil/core';
import { addClass } from '../../utils/helpers/helpers';

@Component({
  tag: 'lgr-select-option',
  styleUrl: 'selectOption.scss',
  shadow: true,
})
export class SelectOption {
  @Element() el!: HTMLLgrSelectOptionElement;
  /**
   * The value of the option.
   */
  @Prop() value: string = '';

  /**
   * Event emitted every time there is a click on the component.
   */
  @Event({ bubbles: true, composed: true }) lgrSelectOptionClicked!: EventEmitter<string>;

  /**
   * Indicates whether the option is currently selected or not.
   */
  @Prop({ mutable: true }) selected: boolean = false;
  /**
   *
   */
  @Prop({ reflect: true }) paddingLeftLarge: boolean = false;

  private isSuboption: boolean = false;
  private select: HTMLLgrInputSelectElement | null = null;

  connectedCallback() {
    this.isSuboption = this.el.closest('lgr-select-option-group') !== null;
    this.select = this.el.closest('lgr-input-select');
  }

  @Listen('lgrSelectValueChanged', { target: 'document' })
  handleSelectValueChanged(event: any) {
    if (this.select === event.target) {
      this.selected = this.select?.value === this.value;
    }
  }

  render() {
    return (
      <li
        role="option"
        aria-role="option"
        aria-selected={this.selected}
        value={this.value}
        onMouseDown={this.handleClick}
        class={`${addClass([this.selected ? 'selected' : null, this.isSuboption ? 'lgr-suboption' : null, this.paddingLeftLarge ? 'padding-left-xxxl' : null])}`}
      >
        <slot></slot>
      </li>
    );
  }

  private handleClick = () => {
    this.selected = true;
    this.lgrSelectOptionClicked.emit(this.value);
  };
}
